import React, { useState, useEffect } from "react";

const InventoryPage = ({ supplyCategories = [] }) => {

const [inventory,setInventory] = useState([]);
const [selectedCategory,setSelectedCategory] = useState("");

const [editingId,setEditingId] = useState(null);
const [editedQuantity,setEditedQuantity] = useState("");

const safeNumber = v => {
const n = Number(v);
return isNaN(n)?0:n;
};

/* =========================
CARGAR INVENTARIO
========================= */

const loadInventory = async()=>{

try{

const res = await fetch("/api/list_inventory.php");
const data = await res.json();

if(data.success){
setInventory(data.data || []);
}

}catch(err){
console.error("inventory load error",err);
}

};

useEffect(()=>{
loadInventory();
},[]);

/* =========================
EDITAR CANTIDAD
========================= */

const handleEditQuantity = (item)=>{
setEditingId(item.supply_id);
setEditedQuantity(safeNumber(item.initial_quantity));
};

const handleCancelEdit = ()=>{
setEditingId(null);
setEditedQuantity("");
};

const handleSaveQuantity = async(id)=>{

try{

const res = await fetch("/api/update_inventory.php",{
method:"POST",
headers:{
"Content-Type":"application/json"
},
body:JSON.stringify({
supply_id:id,
initial_quantity:safeNumber(editedQuantity)
})
});

const data = await res.json();

if(data.success){
loadInventory();
setEditingId(null);
setEditedQuantity("");
}

}catch(err){
console.error("update error",err);
}

};

/* =========================
FILTRO CATEGORIA
========================= */

const filteredInventory = selectedCategory !== ""
? inventory.filter(item=>safeNumber(item.category_id) === safeNumber(selectedCategory))
: inventory;

/* =========================
METRICAS PRO
========================= */

const totalInventoryValue = filteredInventory.reduce((sum,item)=>{
const unitCost = safeNumber(item.unit_cost ?? 0);
return sum + (unitCost * safeNumber(item.current_quantity));
},0);

const totalUsed = filteredInventory.reduce((sum,item)=>{
return sum + safeNumber(item.used_quantity);
},0);

/* ✅ USANDO LIMITE REAL DEL BACKEND */
const lowStockItems = filteredInventory.filter(item=>
safeNumber(item.current_quantity) <= safeNumber(item.low_stock_threshold)
);

/* =========================
HELPERS
========================= */

/* ✅ USANDO LIMITE REAL DEL BACKEND */
const isLowStock = item =>
safeNumber(item.current_quantity) <= safeNumber(item.low_stock_threshold);

/* =========================
RENDER
========================= */

return(

<div className="mt-6">

<div className="bg-[#F9EFD7] p-4 rounded-lg shadow">

<h3 className="text-lg font-semibold text-[#3F1907] mb-4">
Inventario de Insumos
</h3>

{/* KPI */}

<div className="grid md:grid-cols-1 gap-4 mb-4">

<div className="bg-white p-3 rounded shadow">

<p className="text-sm text-gray-500">
Valor Inventario
</p>

<p className="text-lg font-bold text-[#3F1907]">
${totalInventoryValue.toFixed(2)}
</p>

</div>

</div>

{/* FILTRO */}

<div className="mb-4">

<label className="block text-sm font-bold text-[#3F1907] mb-1">
Filtrar por Categoría
</label>

<select
value={selectedCategory}
onChange={e=>setSelectedCategory(e.target.value)}
className="w-full px-3 py-2 border border-[#58735A] rounded-md bg-[#F9EFD7]"
>

<option value="">
Todas
</option>

{supplyCategories.map(cat=>(
<option key={cat.id} value={cat.id}>
{cat.name}
</option>
))}

</select>

</div>

{/* ALERTA */}

{lowStockItems.length>0 &&(

<div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4">
⚠ {lowStockItems.length} insumos con stock bajo
</div>

)}

{/* TABLA */}

<div className="overflow-x-auto">

<table className="min-w-full divide-y divide-[#58735A]">

<thead className="bg-[#58735A]">

<tr>

<th className="px-4 py-3 text-left text-xs text-[#F9EFD7] uppercase">
Insumo
</th>

<th className="px-4 py-3 text-left text-xs text-[#F9EFD7] uppercase">
Unidad
</th>

<th className="px-4 py-3 text-left text-xs text-[#F9EFD7] uppercase">
Inicial
</th>

<th className="px-4 py-3 text-left text-xs text-[#F9EFD7] uppercase">
Gastado
</th>

<th className="px-4 py-3 text-left text-xs text-[#F9EFD7] uppercase">
Actual
</th>

<th className="px-4 py-3 text-left text-xs text-[#F9EFD7] uppercase">
Acciones
</th>

</tr>

</thead>

<tbody className="bg-[#F9EFD7] divide-y divide-[#58735A]">

{filteredInventory.map(item=>(

<tr key={item.supply_id}>

<td className="px-4 py-3 text-sm text-[#3F1907]">
{item.name}
</td>

<td className="px-4 py-3 text-sm text-[#3F1907]">
{item.unit}
</td>

<td className="px-4 py-3 text-sm">

{editingId===item.supply_id ? (

<input
type="number"
value={editedQuantity}
onChange={e=>setEditedQuantity(e.target.value)}
className="w-20 border rounded px-2"
/>

):(

safeNumber(item.initial_quantity).toFixed(2)

)}

</td>

<td className="px-4 py-3 text-sm text-[#3F1907]">
{safeNumber(item.used_quantity).toFixed(2)}
</td>

<td className={`px-4 py-3 text-sm ${
isLowStock(item)
?"text-red-600 font-bold"
:"text-[#3F1907]"
}`}>

{safeNumber(item.current_quantity).toFixed(2)}

{isLowStock(item)&&(

<span className="ml-2 text-xs bg-red-200 px-2 py-1 rounded">
STOCK BAJO
</span>

)}

</td>

<td className="px-4 py-3 text-sm space-x-2">

{editingId===item.supply_id ?(

<>

<button
onClick={()=>handleSaveQuantity(item.supply_id)}
className="text-green-600"
>
Guardar
</button>

<button
onClick={handleCancelEdit}
className="text-red-500"
>
Cancelar
</button>

</>

):(

<button
onClick={()=>handleEditQuantity(item)}
className="text-blue-600"
>
Editar
</button>

)}

</td>

</tr>

))}

</tbody>

</table>

</div>

</div>

</div>

);

};

export default InventoryPage;